/**
 * [module] : current state name
 */
export interface DebugStatesMap {
	[moduleName: string]: string;
}

export class StatedDebug {
	protected _states: DebugStatesMap = {};

	constructor() {
		if (!__PRODUCTION__) {
			document.addEventListener('keydown', this.keyboardInput.bind(this));
		}
	}

	public setModuleState(moduleName: string, stateName: string): void {
		this._states[moduleName] = stateName;
	}

	public drawModulesMap(): void {
		if (!__PRODUCTION__) {
			for (const key in this._states) {
				if (this._states.hasOwnProperty(key)) {
					console.log('' + key + ' - ' + this._states[key]);
				}
			}
		}
	}

	private keyboardInput(event: KeyboardEvent): void {
		if (!__PRODUCTION__) {
			if (event.code === 'ArrowLeft') {
				this.drawModulesMap();
			}

			if (event.code === 'ArrowRight') {
				console.log(`${__VERSION__} ${__BRANCH__} ${__BUILD_DATE__} ${__GITHASH__}`);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/common/inversify/debug/StatedDebug.ts